module.exports = __webpack_public_path__ + "img/pigduck.6dc3cebb.jpg";